import { Container } from '@features/shared/components/container';
import { Suspense } from 'react';

import { CenterComponent } from './center-component';
import { useNavbarConfig } from './hooks/use-navbar-config';
import { LeftComponent } from './left-component';
import { RightComponent } from './right-component';

export type NavbarProps = {
  title?: string;
};

export function Navbar() {
  const { backgroundColor } = useNavbarConfig();

  return (
    <>
      <Container
        as="nav"
        className={`w-screen shadow-sm flex flex-col justify-center`}
        style={{ backgroundColor }}
      >
        <div className="relative flex flex-row items-center justify-center h-20">
          <div className="absolute left-0">
            <LeftComponent />
          </div>
          <div className="flex">
            <CenterComponent />
          </div>
          <div className="absolute right-0">
            <Suspense fallback={null}>
              <RightComponent />
            </Suspense>
          </div>
        </div>
      </Container>
    </>
  );
}
